import type { AnalysisDaySchema } from '@libs/data-access/entities'
import { analysisService } from '@libs/data-access/queries'
import { notifications, NumberInput } from '@libs/ui/ds'
import { useEffect, useState, type FC } from 'react'

import { getStatistics } from '../utils/getStatistics'

import styles from './InputRevenue.module.css'

type Props = {
  real: boolean
  data: AnalysisDaySchema
  account_currency: string
  locationId: number
  teamId: number | undefined
}
const InputRevenue: FC<Props> = ({
  real,
  data,
  account_currency,
  locationId,
  teamId
}) => {
  const { sales_in_euro, date } = getStatistics(real, data)

  const [value, setValue] = useState(sales_in_euro)

  useEffect(() => {
    setValue(sales_in_euro)
  }, [sales_in_euro])

  const updateRevenueMutation = analysisService.updateRevenue({
    onError: ({ error }) => {
      notifications.errorAdapter({ error })
    }
  })

  const updateRevenue = (value: string) => {
    // Avoid unnecessary updates, also protects from trigger when changing from real <-> budget
    const valueNumber = Number(value)
    if (valueNumber === sales_in_euro) {
      return
    }

    const payload = real
      ? { actual_sales: valueNumber }
      : { budget_sales: valueNumber }

    const queryParams = teamId
      ? {
          date,
          location_id: locationId.toString(),
          team_id: teamId.toString()
        }
      : {
          date,
          location_id: locationId.toString()
        }
    updateRevenueMutation.mutate({
      payload,
      queryParams
    })
  }

  return (
    <div className='relative pb-2.5'>
      <NumberInput
        value={value.toString()}
        key={`input_${date}_${locationId}_${teamId}`}
        size='s'
        classNames={{
          inner: `text-center text-neutral-500 ${styles.InputNumberTurnover} ${sales_in_euro > 0 && 'text-semantic-blue-400'}`,
          root: 'w-3/4 mx-auto',
          input: `w-3/4 text-center text-xs ${sales_in_euro > 0 && 'text-semantic-blue-400'}`
        }}
        onChange={e => setValue(Number(e.target.value))}
        onDebouncedChange={updateRevenue}
        debounceDelay='long'
        suffix={account_currency}
      />
    </div>
  )
}

export default InputRevenue
